import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import { recursionCopy } from '@/views/customer/roleManage/utils';
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    tagData: {
      type: Array,
      default() {
        return [];
      }
    },
    tagList: {
      type: Array,
      default() {
        return [];
      }
    },
    format: {
      type: String,
      default: 'first'
    }
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible) {
        this.arr = [];
        this.tagListData = this.tagData;
        this.tagList2 = this.tagList;
      }
    }
  },
  data() {
    return {
      tagLeftIndex: 0,
      arr: [],
      tagList2: [],
      tagName: '',
      tagListData: [],
      tagValueList: [],
      tagValue: ''
    };
  },
  methods: {
    handleSure() {
      let arr = [];
      let arr2 = [];
      this.tagList2.map(item => {
        let obj = [];
        let obj3 = [];
        item.map(item2 => {
          obj.push(item2.sort);
          obj3.push({
            fieldName: item2.fieldName,
            fieldValue: item2.fieldValue
          });
        });
        arr.push(obj);
        arr2.push(obj3);
      });
      let obj2 = [];
      let obj4 = [];
      this.arr.map(item => {
        obj2.push(item.sort);
        obj4.push({
          fieldName: item.fieldName,
          fieldValue: item.fieldValue
        });
      });
      arr.push(obj2);
      arr2.push(obj4);
      console.log(arr, arr.join('-'));
      this.$emit('cancel');
      if (this.format == 'first') {
        this.$emit('ok', this.tagList2, this.arr, arr.join('-'));
      } else {
        console.log(this.tagList2, this.arr, 1111);
        let val = JSON.stringify(arr2) == '[[]]' ? '' : JSON.stringify(arr2);
        this.$emit('ok', this.tagList2, this.arr, val);
      }
    },
    choiceItemFun(item) {
      item.choice = !item.choice;
      if (item.choice) {
        this.arr.push(item);
      } else {
        let choice = this.isInArray(this.arr, item.sort, item.fieldValue);
        if (choice != null) {
          this.arr.splice(choice, 1);
        } else {
          let tagList = recursionCopy(this.tagList2);
          tagList.map((item2, index) => {
            let choice2 = this.isInArray(item2, item.sort, item.fieldValue);
            console.log(choice2, 55521);
            if (choice2 != null) {
              tagList[index].splice(choice2, 1);
            }
            if (tagList[index].length == 0) {
              tagList.splice(index, 1);
            }
          });
          console.log(tagList, 444);
          this.tagList2 = tagList;
        }
      }
    },
    isInArray(arr, value, value2) {
      let val = this.format == 'first' ? value : value2;
      for (var i = 0; i < arr.length; i++) {
        let val2 = this.format == 'first' ? arr[i].sort : arr[i].fieldValue;
        if (val == val2) {
          return i;
        }
      }
      return null;
    },
    tagChange() {
      this.tagLeftIndex = 0;
      this.tagValue = '';
      if (this.tagName) {
        let serachTag = [];
        this.tagData.map(item => {
          if (item.fieldKey.indexOf(this.tagName) > -1) {
            serachTag.push(item);
          }
        });
        this.tagListData = serachTag;
      } else {
        this.tagListData = this.tagData;
      }
    },
    tagValueChange() {
      if (this.tagValue) {
        let serachTag = [];
        this.tagData[this.tagLeftIndex].children.map(item => {
          if (item.fieldValue.indexOf(this.tagValue) > -1) {
            serachTag.push(item);
          }
        });
        console.log(serachTag, 2222);
        this.tagValueList = serachTag;
      }
    },
    handleClose(data) {
      let choice = this.isInArray(this.arr, data.sort, data.fieldValue);
      if (choice != null) {
        const tags = this.arr.filter(tag => tag.sort !== data.sort);
        this.arr = tags;
      } else {
        let tagList = recursionCopy(this.tagList2);
        tagList.map((item2, index) => {
          let choice2 = this.isInArray(item2, data.sort, data.fieldValue);
          console.log(choice2, 55521);
          if (choice2 != null) {
            tagList[index].splice(choice2, 1);
          }
          if (tagList[index].length == 0) {
            tagList.splice(index, 1);
          }
        });
        console.log(tagList, 444);
        this.tagList2 = tagList;
      }
      this.choiceItemFun(data);
    }
  }
};